import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import AppointmentTypeButton from "./AppointmentTypeButton.js";
const AppointmentTypeButtonContainer = ({
  appointmentType,
  toolTip,
  onClick,
  onClickToolTip,
  ...rest
}) => {
  const { getLabel } = useIntl();
  const labels = React.useMemo(() => {
    const { name, description, duration } = appointmentType;
    const durationLabel = duration.amount > 0 ? `${duration.amount} ${getLabel(
      `appointments.shortTimeUnits.${duration.unit.toLowerCase()}`
    )}` : "";
    return {
      name,
      description: `${durationLabel}${durationLabel.length && description?.length ? " · " : ""}${description ?? ""}`
    };
  }, [getLabel, appointmentType]);
  const onClickHandler = React.useCallback(
    () => onClick(appointmentType),
    [onClick, appointmentType]
  );
  const onClickToolTipHandler = React.useCallback(() => {
    if (!toolTip || !onClickToolTip) {
      return;
    }
    onClickToolTip(toolTip);
  }, [onClickToolTip, toolTip]);
  return /* @__PURE__ */ React.createElement(
    AppointmentTypeButton,
    {
      ...rest,
      price: appointmentType.price,
      labels,
      toolTip,
      onClick: onClickHandler,
      onClickToolTip: onClickToolTipHandler
    }
  );
};
export {
  AppointmentTypeButtonContainer as default
};
//# sourceMappingURL=AppointmentTypeButtonContainer.js.map
